module.exports = __webpack_public_path__ + "img/Managment, Economics & Finance.f3d51705.jpg";